import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class FieldInputAction extends AbstractProvidedClass {
    constructor(provider, element, field, func) {
        super(provider);

        this.element = element;
        this.field = field;
        this.oldValue = field.getValue();
        this.func = func;
    }

    update() {
        this.func(this.element, this.field.getValue());
    }

    finish() {
        this.newValue = this.field.getValue();
        if (!this.element || this.newValue === this.oldValue) {
            this.actions.discard();
            return;
        }
        let result = this.func(this.element, this.newValue);
        if (result === false) {
            this.func(this.element, this.oldValue);
            this.element.row?.updateImg();
            this.actions.discard();
            return;
        }
        this.element.row?.updateImg();
        this.actions.finish();
    }

    undo() {
        this.func(this.element, this.oldValue);
        this.element?.row?.updateImg();
        this.getTab('info').reload(this.element);
    }

    redo() {
        this.func(this.element, this.newValue);
        this.element?.row?.updateImg();
        this.getTab('info').reload(this.element);
    }
}
